<mat-dialog-content class="dialog-content--leveys" [style.max-height]="vaihe() === 'tosite' ? '80vh' : null">
  @if (vaihe() !== 'tosite') {
    <lemon-dialog-header>Lisää {{ data.kohteet.length }} tositetta tositteen luvun testisettiin</lemon-dialog-header>
  } @else {
    <lemon-dialog-header>{{ indeksi() + 1 }} / {{ data.kohteet.length }} — {{ kohteenNimi(nykyinenKohde) }}</lemon-dialog-header>
  }

  @if (vaihe() === 'lataa') {
    <div class="rivi-lataa">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Haetaan settejä…</span>
    </div>
  }

  @if (vaihe() === 'virhe') {
    <p class="virhe-p">Settien haku epäonnistui.</p>
  }

  @if (vaihe() === 'setti') {
    <p class="selite-teksti">Valitse setti, johon tositteet lisätään. Tämän jälkeen jokaiselle tositteelle syötetään oikeat tiedot käsin, yksi kerrallaan.</p>

    <h3 class="setti-otsikko">Olemassa oleva setti</h3>
    @if (setit().length === 0) {
      <div class="ei-list-info">Ei vielä settejä. Luo uusi alla.</div>
    } @else {
      <mat-radio-group [formField]="settiValinta" class="setti-radiogroup">
        @for (setti of setit(); track setti.avain) {
          <mat-radio-button [value]="setti.avain">
            {{ setti.nimi }}
            <span class="setti-kpl-maara">({{ setti.testitapausLkm }} kpl)</span>
            @if (valituistaJoSetissa(setti.avain); as lkm) {
              <span class="setti-jo-mukana">{{ lkm }} valituista on jo tässä setissä</span>
            }
          </mat-radio-button>
        }
      </mat-radio-group>
    }

    <h3 class="setti-otsikko">Tai luo uusi setti</h3>
    <mat-form-field class="uusi-setti-nimi-kentta">
      <mat-label>Uuden setin nimi</mat-label>
      <input matInput [formField]="uudenSetinNimi" placeholder="esim. Kuitit Q3 2026" />
    </mat-form-field>
  }

  @if (vaihe() === 'tosite' && nykyinenKohde) {
    <div class="tosite-vaihe-container">
      <div #tositeContainer class="tosite-esikatselu-container">
        @if (nykyinenKohde.tyyppi === 'ladattu') {
          @if (esikatseluOnPdf()) {
            @if (esikatseluPdfUrl()) {
              <div app-pdf-viewer [url]="esikatseluPdfUrl()"></div>
            } @else {
              <mat-spinner diameter="24" class="esikatselu-spinner"></mat-spinner>
            }
          } @else {
            <img [src]="esikatseluUrl()" class="esikatselu-kuva" alt="Ladattu tosite" />
          }
        } @else if (naytettavatTositteetJaSivut() === null) {
          <mat-spinner diameter="24" class="esikatselu-spinner"></mat-spinner>
        } @else if (!naytettavatTositteetJaSivut().length) {
          <div class="tyhja-viesti">Tositetta ei löydy lemonatorista</div>
        } @else {
          <div app-kirjanpito-tosite-naytto [piilotaYlaControllit]="true" [naytaRuksi]="false" [scrollContainerRef]="tositeContainerRef" [naytettavaKirjausObservable]="tyhjaKirjausObservable" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut()"></div>
        }
      </div>

      <div class="tosite-lomake-container">
        @if (nykyinenJoValitussaSetissa) {
          <div class="jo-setissa-huomautus">Tosite on jo setissä "{{ settiNimi() }}". Sitä ei voi lisätä toista kertaa; siirry seuraavaan Ohita-painikkeella.</div>
        } @else if (nykyisenMuuJasenyys; as muu) {
          <div class="muu-setti-huomautus">Tosite on jo setissä "{{ muu.settiNimi }}". Oikeat tiedot on esitäytetty sieltä.</div>
        }
        <p class="selite-teksti">
          Syötä oikeat tiedot tositteen kuvasta, nimi ja tunnus kuten ne on tositteeseen painettu. Toimittaja tyhjänä tarkoittaa, ettei myyjää voi lukea tositteesta. Päivämäärä ja summa ovat valinnaisia; tyhjää kenttää ei pisteytetä. Odotettu rekisterin toimittaja johdetaan tunnuksesta ja nimestä; valitse se käsin vain, jos päättely
          menee väärin.
        </p>

        <app-metatiedot-form [form]="metatiedotForm" [naytaToimittajaValinta]="nykyinenKohde.tyyppi === 'lemonaid'" [toimittajaRekisteri]="toimittajaRekisteri()" [odotettuToimittajaHint]="odotettuToimittajaTeksti()"></app-metatiedot-form>

        @if (nykyinenKohde.tyyppi === 'lemonaid') {
          <div class="viiteblokki">
            <div class="viiteblokki-otsikko">Tositteen nykyiset tiedot lemonaidissa (viitteeksi, ei kopioidu automaattisesti)</div>
            @if (viitetiedotLataa()) {
              <mat-spinner diameter="16"></mat-spinner>
            } @else if (!viitetiedot()) {
              <div class="ei-saatavilla">Ei saatavilla.</div>
            } @else {
              <table class="viite-taulukko">
                <tr>
                  <td class="viite-solu">Toimittaja</td>
                  <td class="viite-solu">{{ viitetiedot().toimittajaNimi ?? (viitetiedot().toimittajaAvain ? viitetiedot().toimittajaAvain + ' (ei rekisterissä)' : '—') }}</td>
                  <td><app-button (click)="kopioi('toimittaja')" [disabled]="!viitetiedot().toimittajaNimi" actionId="Kopioi viitetiedon toimittaja">Kopioi</app-button></td>
                </tr>
                <tr>
                  <td class="viite-solu">Tunniste</td>
                  <td class="viite-solu">{{ viitetiedot().toimittajaTunniste ?? '—' }}</td>
                  <td><app-button (click)="kopioi('businessId')" [disabled]="!viitetiedot().toimittajaTunniste" actionId="Kopioi viitetiedon tunniste">Kopioi</app-button></td>
                </tr>
                <tr>
                  <td class="viite-solu">Päivämäärä</td>
                  <td class="viite-solu">{{ viitetiedot().paivamaara ?? '—' }}</td>
                  <td><app-button (click)="kopioi('paivamaara')" [disabled]="!viitetiedot().paivamaara" actionId="Kopioi viitetiedon päivämäärä">Kopioi</app-button></td>
                </tr>
                <tr>
                  <td class="viite-solu">Summa</td>
                  <td class="viite-solu">{{ viitetiedot().summa !== null ? (viitetiedot().summa | number: '1.2-2') + ' €' : '—' }}</td>
                  <td><app-button (click)="kopioi('summa')" [disabled]="viitetiedot().summa === null" actionId="Kopioi viitetiedon summa">Kopioi</app-button></td>
                </tr>
              </table>
            }
          </div>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions-gap">
  @if (vaihe() === 'virhe') {
    <app-secondary-button (click)="lopeta()" actionId="Sulje (lisää tositteet testisettiin dialog)">Sulje</app-secondary-button>
  }
  @if (vaihe() === 'setti') {
    <app-secondary-button (click)="lopeta()" [disabled]="tallennetaan()" actionId="Peruuta (lisää tositteet testisettiin dialog)">Peruuta</app-secondary-button>
    <app-primary-button (click)="valitseSetti()" [disabled]="!voiValitaSetin() || tallennetaan()" actionId="Valitse setti (lisää tositteet testisettiin dialog)">
      @if (tallennetaan()) {
        <mat-spinner diameter="16" class="nappi-spinner"></mat-spinner>
      }
      Jatka tositteisiin
    </app-primary-button>
  }
  @if (vaihe() === 'tosite') {
    <span class="tallennus-tila">Lisätty {{ lisatty() }}, ohitettu {{ ohitettu() }}</span>
    <app-secondary-button (click)="lopeta()" [disabled]="tallennetaan()" actionId="Lopeta (lisää tositteet testisettiin dialog)">Lopeta</app-secondary-button>
    <app-button (click)="ohita()" [disabled]="tallennetaan()" actionId="Ohita tosite (lisää tositteet testisettiin dialog)">Ohita</app-button>
    <app-primary-button (click)="tallennaJaSeuraava()" [disabled]="tallennetaan() || nykyinenJoValitussaSetissa" actionId="Tallenna ja seuraava (lisää tositteet testisettiin dialog)" [actionContext]="[metatiedotForm.value]">
      @if (tallennetaan()) {
        <mat-spinner diameter="16" class="nappi-spinner"></mat-spinner>
      }
      Tallenna ja seuraava
    </app-primary-button>
  }
</mat-dialog-actions>
